import React from 'react';
import { MusicDistributionClientContext } from '../../context/MusicDistributionClientContext';
import CustomButton from '../../../common/components/CustomButton';
import CustomSelect from '../../../common/components/CustomSelect';
import CustomTextArea from '../../../common/components/CustomTextAera';
import PopupContainer from '../../../common/components/PopupContainer';
import ErrorMessage from '../../../common/components/ErrorMessage';
import { MusicAlbumEntity } from '../../types/MusicAlbumEntityTypes';
import { FieldValidationErrorsType, showErrorFlush } from '../../../common/form/FrekulForm';

export default function MusicAlbumDeleteCancelPopup2({
  musicAlbum, onCancel, onDone, cancelReasonOptions,
} : {
  musicAlbum: MusicAlbumEntity,
  onCancel: () => void,
  onDone: () => void,
  cancelReasonOptions: {
    text: string,
    value: string,
  }[],
}) {
  const { cancelMusicAlbum } = React.useContext(MusicDistributionClientContext);
  const [cancelReason, setCancelReason] = React.useState('');
  const [cancelReasonOthers, setCancelReasonOthers] = React.useState('');
  const [errors, setErrors] = React.useState<{[key: string]: FieldValidationErrorsType}>({});

  const handleSubmit = () => {
    cancelMusicAlbum(musicAlbum.id, cancelReason, cancelReasonOthers).then((responseData) => {
      if (responseData.result) {
        onDone();
      } else {
        setErrors(responseData.validationErrors as { [key: string]: FieldValidationErrorsType });
        showErrorFlush('入力内容に不備があります。');
      }
    });
  };

  return (
    <PopupContainer title="リリースの配信停止について" onClose={() => { onCancel(); }}>
      <form className="cake_ajax_form">
        <div className="form__body">
          <p>
            「
            {musicAlbum.title}
            」を配信停止にします。
          </p>
          <p>停止理由について、以下からもっとも近いものを選んでください。</p>
          <dl>
            <dd>
              <CustomSelect
                value={cancelReason}
                setValue={(value) => setCancelReason(value)}
                validationErrors={errors.cancel_reason}
                // eslint-disable-next-line max-len
                options={cancelReasonOptions.map((option) => ({ title: option.text, value: option.value }))}
              />
              {cancelReason === 'others' && (
                <dd>
                  <CustomTextArea
                    value={cancelReasonOthers}
                    setValue={(value) => { setCancelReasonOthers(value); }}
                  />
                </dd>
              )}
              <ErrorMessage type="error" validationErrors={errors.cancel_reason_others} />
            </dd>
          </dl>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => { onCancel(); }}>キャンセル</CustomButton>
              <CustomButton type="default-split" onClick={() => { handleSubmit(); }}>配信停止依頼</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}

